import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'; 
import md5 from 'js-md5'; // 确保引入
import api from './Interceptor';


Vue.prototype.$md5 = md5; // 确保挂载
Vue.config.productionTip = false
Vue.use(api);//注册组件


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
